(function($){

    var $controller  = {

        init: function() {
            this.listen();
        },
        
        listen: function() {
            $('.filter-toggle-trigger').click(function($evt) {
                $controller.handle($(this), $evt, '.form--container', '.form-toggle--container');
            });
            $('.save-trigger').click(function($evt) {
                $controller.handle($(this), $evt, '.save-items--container', '.save-heading--container');
            });
            $(window).resize(function() {
                $('.form-toggle--container,.save-heading--container').attr('aria-expanded', false).removeClass('open');
                $('.form--container,.save-items--container').removeClass('open');
            });
        },

        handle: function($this, $evt, $container_selector, $trigger_container_selector) {
            $evt.preventDefault();
            var $tcontainer = $this.closest($trigger_container_selector);
            if($tcontainer.hasClass('open')) {
                // close
                $tcontainer
                    .attr('aria-expanded', false)
                        .removeClass('open');
            } else {
                // open
                $tcontainer
                    .attr('aria-expanded', true)
                        .addClass('open');
            }
            $($container_selector).toggleClass('open');
        }

    };

    $controller.init();

})(jQuery);


// WEBPACK FOOTER //
// ./tbo/js/listen/toggle.js